module.exports = __webpack_public_path__ + "static/media/Asset 4.701fb5ab.png";